// extracted by mini-css-extract-plugin
var _1 = "w8uEpj2xto2chCijEmmf";
export { _1 as "root" }
